import { QueryFactory } from "../../../../Common";
export const QGetPlayer = QueryFactory("GetPlayer");
//# sourceMappingURL=QGetPlayer.js.map